import React from "react";
import { Box, MenuItem } from "@mui/material";
import { LEAD_STATUS_DEFINITIONS } from "../constants/leadStatuses";
import LeadStatusIcon from "./LeadStatusIcon";

function statusMenuItem(value) {
  return (
    <MenuItem key={value} value={value}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box sx={{ mr: 1, display: "flex", alignItems: "center" }}>
          <LeadStatusIcon status={value} size={20} />
        </Box>
        <span>{value}</span>
      </Box>
    </MenuItem>
  );
}

// Call these as functions inside Select — {LeadStatusFilterMenuItems()} —
// so each MenuItem is a direct child. MUI Select ignores clicks on items
// nested in a custom component.
export function LeadStatusFilterMenuItems({ includeAll = true } = {}) {
  return [
    includeAll ? (
      <MenuItem key="all" value="all">
        All Statuses
      </MenuItem>
    ) : null,
    ...LEAD_STATUS_DEFINITIONS.map(({ value }) => statusMenuItem(value)),
  ];
}

export function LeadStatusSelectMenuItems() {
  return LEAD_STATUS_DEFINITIONS.map(({ value }) => statusMenuItem(value));
}
